// src/components/ui/Card.jsx (versão 0.1.9)

import React from 'react';

/**
 * Componente Card moderno e elegante. 
 * É o container principal com borda e sombra mais proeminente.
 */
const Card = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    // Classes Tailwind: 
    // - focus:outline-none: Remove o contorno de foco padrão (útil por segurança).
    // - transition-all duration-500: Transições suaves para a sombra e borda.
    className={`
        rounded-xl 
        border 
        bg-white 
        dark:border-gray-800 
        dark:bg-gray-950 
        shadow-sm 
        ring-1 ring-gray-100/50 
        overflow-hidden
        focus:outline-none 
        transition-all duration-500 
        ${className}
    `}
    {...props}
  />
));

Card.displayName = "Card";

export default Card;